<c-full-page-layout
  [hasFooter]="true"
  [config]="layoutConfig"
  [attr.aria-hidden]="isBrandedContentStep() ? 'true' : null">
  <div full-page-header>
    <div class="header">
      @if (showInitialSkeleton()) {
        <ion-skeleton-text animated style="width: 200px; height: 24px; margin: 20px 0 10px 0"></ion-skeleton-text>
      } @else {
        <h1>{{ stepTitle() }}</h1>
      }
      <c-button type="secondary" size="small" [iconOnly]="true" [icon]="closeIcon" (action)="closeModal('cancel')" />
    </div>
    <ion-progress-bar [value]="progressBarValue()" />
  </div>

  <div full-page-content>
    @if (showInitialSkeleton()) {
      <div class="loading-container">
        <ion-skeleton-text animated style="width: 250px; height: 24px"></ion-skeleton-text>
      </div>
    }
    <ion-nav #ionNav></ion-nav>
  </div>

  <div full-page-footer class="footer">
    @if (currentStep()?.navigation.isLastStep) {
      <c-button [loading]="loadingNext()" (action)="complete()">
        {{ currentStep()?.navigation.buttons.completeLabel || ('common.complete' | transloco) }}
      </c-button>
    }

    @if (currentStep()?.navigation.buttons.showNext) {
      <c-button [loading]="loadingNext()" (action)="next()">
        {{ 'common.next' | transloco }}
      </c-button>
    }

    @if (currentStep()?.navigation.buttons.showPrevious) {
      <c-button type="secondary" [loading]="loadingPrevious()" (action)="previous()">
        {{ 'common.go-back' | transloco }}
      </c-button>
    }
  </div>
</c-full-page-layout>

@if (isBrandedContentStep()) {
  <div class="branded-step">
    <c-branded-content-step
      [content]="currentStep().step.content"
      [buttonLabel]="
        currentStep().navigation.isLastStep
          ? (currentStep().navigation.buttons?.completeLabel || ('common.complete' | transloco))
          : ('common.next' | transloco)
      "
      [showPrevious]="currentStep().navigation.buttons?.showPrevious"
      [loading]="loadingNext()"
      [previousLoading]="loadingPrevious()"
      (action)="onBrandedAction()"
      (previous)="previous()" />
  </div>
}
